import React from 'react';

export interface IRootContext {
  node?: HTMLElement;
}

export const RootContext = React.createContext<IRootContext | undefined>(
  undefined,
);

export const useRootContext = () => {
  const context = React.useContext(RootContext);

  return context;
};
